// src/composables/usePromo.js
// Shared promo-offer logic (DRY): used by the public LandingPage AND the
// authenticated TeacherDashboard so the shiny offer card appears for visitors
// and logged-in users alike.
import { ref } from 'vue';
import { useApi } from './useApi';

export function usePromo() {
  const { get: apiGet } = useApi();
  const promo = ref(null);
  const showPromo = ref(false);

  /** Fetch the active promo (date window enforced server-side) and show the
   *  card once per session per offer. delayMs lets the page settle first. */
  const fetchPromo = async ({ delayMs = 800 } = {}) => {
    try {
      const data = await apiGet('/public/promo');
      if (data?.active && data.promo) {
        const key = `promo_dismissed_${data.promo.endDate || 'x'}`;
        if (sessionStorage.getItem(key)) return;
        promo.value = data.promo;
        setTimeout(() => { showPromo.value = true; }, delayMs);
      }
    } catch (e) {
      // Promo must never break the host page.
      console.warn('Promo lookup failed', e);
    }
  };

  const dismissPromo = () => {
    sessionStorage.setItem(`promo_dismissed_${promo.value?.endDate || 'x'}`, '1');
  };

  return { promo, showPromo, fetchPromo, dismissPromo };
}
